export const Featured = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        width={'100%'}
        height={'100%'}
    >
        <path
            className="ico_pri"
            d="M15.481 34.526a2.999 2.999 0 0 0 2.116 2.1l14.373 3.852a3 3 0 0 0 3.674-2.122l6.243-23.298a3 3 0 0 0-2.121-3.674L25.393 7.533a3 3 0 0 0-3.674 2.121l-1.678 6.262a5.987 5.987 0 0 1 1.62 1.68l1.99-7.424a1 1 0 0 1 1.224-.707l14.373 3.85a1 1 0 0 1 .707 1.226l-6.242 23.298a1 1 0 0 1-1.225.707l-14.373-3.851a1 1 0 0 1-.71-.714l-1.924.545Z"
        />
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M9.466 20.317a2 2 0 0 0-1.38 2.469l1.87 6.6a2 2 0 0 0 2.469 1.38l6.6-1.87a2 2 0 0 0 1.38-2.469l-1.869-6.6a2 2 0 0 0-2.47-1.38l-6.6 1.87ZM6.162 23.33a4 4 0 0 1 2.76-4.939l6.6-1.869a4 4 0 0 1 4.938 2.76l1.87 6.6a4 4 0 0 1-2.76 4.938l-6.6 1.87a4 4 0 0 1-4.939-2.76l-1.869-6.6Z"
            clipRule="evenodd"
        />
        <path
            className="ico_pri"
            d="M13.027 23.704a1.35 1.35 0 1 0-2.516-.98 1.35 1.35 0 0 0 2.516.98Zm4.975 2.789a1.35 1.35 0 1 0-2.516-.98 1.35 1.35 0 0 0 2.516.98ZM32.65 23.33c-.47-.61-1.87-2.47-2.41-3.79a.454.454 0 0 0-.69-.19c-1.15.89-3.35 1.82-4.02 2.09-.97.32-1.73 1.2-1.81 2.36-.07 1.07.56 2.1 1.53 2.54.7.31 1.43.31 2.06.06.11-.04.21.06.17.17-.19.44-.52.94-1.1 1.4-.18.14-.12.43.1.48l1.86.5c.22.06.41-.16.33-.37a3.62 3.62 0 0 1-.26-1.77c.01-.11.16-.15.23-.06.42.53 1.06.91 1.82.98 1.07.11 2.14-.48 2.61-1.45.51-1.06.28-2.21-.42-2.97v.02Z"
        />
    </svg>
);
